module.exports = __webpack_public_path__ + "img/huehnerfleischfront.2373f2c6.png";